<script lang="ts" setup>
import ProductGrayButton from '~/components/products/ProductGrayButton.vue'
import ProductText from '~/components/products/ProductText.vue'
import ImageType from '~/enums/image-type'
import helpers from '~/helpers'
import type { ProductData } from '~/types/products'

const props = defineProps<{
  productData: ProductData
}>()

const types = [ImageType.Thumbnail144p, ImageType.Original]

const router = useRouter()

const brandData = computed(() => props.productData.relationships.brand?.data)

const imageUrl = computed(() => brandData.value?.meta?.imageUrl)

// const imageUrl = computed(() => {
//   if (!brandData.value?.relationships?.images) {
//     return null
//   }
//
//   const imageUrls = helpers.getImageUrls(brandData.value.relationships.images.data)
//
//   return imageUrls ? helpers.getImageUrl(imageUrls, types) : null
// })
</script>

<template>
  <div v-if="brandData" class="brand-section flex items-start justify-between md:flex-col md:justify-start">
    <div class="mr-4 flex md:mb-4 md:mr-0">
      <img
        v-lazy="imageUrl"
        :alt="brandData.attributes.name + ' logotype'"
        class="mr-2 size-[44px] rounded-full object-contain"
        loading="lazy"
      >

      <div class="items-between flex h-full flex-col">
        <ProductText class="mb-1" text="Бренд" />

        <strong class="text-base font-medium leading-normal tracking-[-0.01em] text-main-dark md:text-base">
          {{ brandData.attributes.name }}
        </strong>
      </div>
    </div>

    <ProductGrayButton
      :title="'Все\xA0товары бренда'"
      @click.prevent="router.push({ path: helpers.getBrandPath(brandData) })"
    />
  </div>
</template>

<style lang="scss" scoped>
.brand-section {
  @media (max-width: 420px) {
    flex-direction: column !important;
    justify-content: start !important;

    > div {
      margin-bottom: 8px;
    }
  }
}
</style>
